<script setup lang="ts">
  import { computed, watch } from 'vue';
  import StudentPIITooltip from '@/components/StudentPIITooltip.vue';
  import GbInlineMessage from '@/components/GbInlineMessage.vue'
  import InputText from 'primevue/inputtext'
  import { announce } from '@/util/live_announcer'

  const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    isDuplicate: {
        type: Boolean,
        required: true,
    },
    maxReached: {
        type: Boolean,
        default: false,
    },
    errorMessage: {
        type: String,
        default: '',
    },
    isLoading: {
        type: Boolean,
        default: false,
    }
  });

  const emit = defineEmits(['update:modelValue', 'enter']);
  const inputValue = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val),
  });

  const showsDuplicateWarning = computed(() => !!inputValue.value && props.isDuplicate && !props.maxReached)
  watch(showsDuplicateWarning, shown => {
    if (shown) {
      announce('A folder in your library already exists with this name.', { assertive: true })
    }
  })
</script>
<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2 mb-1">
      <label for="folderName" class="text-lg font-medium text-gray-700">
        Folder Name
      </label>
      <StudentPIITooltip />
    </div>
    <InputText
      id="folderName"
      name="folderName"
      v-model="inputValue"
      placeholder="Folder Name"
      class="w-full fs-exclude"
      :disabled="maxReached || isLoading"
      @keyup.enter="$emit('enter')"
    />
    <GbInlineMessage v-if="maxReached" gbTheme="red" class="mt-1">
      <span class="font-bold">Maximum folders reached. </span>
      <span>You must delete or archive active folders to add a new one.</span>
    </GbInlineMessage>
    <GbInlineMessage v-if="showsDuplicateWarning" gbTheme="red" class="mt-1">
      <div class="flex items-center gap-2">
        <span class="material-icons-round text-red-400">warning_amber</span>
        <span>A folder in your library already exists with this name.</span>
      </div>
    </GbInlineMessage>
    <GbInlineMessage v-if="errorMessage && !maxReached" gbTheme="red" class="mt-1">
      {{ errorMessage }}
    </GbInlineMessage>
  </div>
</template>
